"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConfigStore_1 = require("../Store/ConfigStore");
var Store_1 = require("../Store/Store");
var assign_1 = require("../Util/assign");
var ConfigState_1 = require("./ConfigState");
var State = /** @class */ (function () {
    function State(options) {
        if (options === void 0) { options = {}; }
        this.history = [{}];
        this.stores = {};
        this.isTraversing = false;
        this.config = new ConfigState_1.default();
        this.isActioning = false;
        this.historyIndex = 0;
        assign_1.default(this.config, options);
        this.update$ = new this.config.observable(null);
    }
    Object.defineProperty(State.prototype, "value", {
        get: function () {
            return this.history[this.historyIndex];
        },
        enumerable: false,
        configurable: true
    });
    State.prototype.createStore = function (config, initialValue) {
        var stores = this.stores;
        if (process.env.NODE_ENV !== 'production' && this.historyIndex > 0) {
            throw new Error('Cannot create store after state initialisation');
        }
        // Shallow copy value and overwrite so new keys can be added
        this.history[0] = __assign({}, this.value);
        var storeConfig = assign_1.default(new ConfigStore_1.default(), config);
        var name = storeConfig.name, model = storeConfig.model, actions = storeConfig.actions;
        if (process.env.NODE_ENV !== 'production') {
            if (!name || typeof name !== 'string') {
                throw new TypeError('Invalid store name provided');
            }
            if (!model || typeof model !== 'function') {
                throw new TypeError("Invalid store model provided for store `" + name + "`");
            }
            if (!actions || typeof actions !== 'function') {
                throw new TypeError("Invalid actions resolver provided for store `" + name + "`");
            }
        }
        var store = (stores[storeConfig.name] = new Store_1.default(this, storeConfig, initialValue));
        if (process.env.NODE_ENV !== 'production') {
            Object.freeze(this.value);
        }
        return store;
    };
    State.prototype.linkStore = function (store) {
        var _this = this;
        var stores = this.stores;
        if (process.env.NODE_ENV !== 'production' && this.historyIndex > 0) {
            throw new Error('Cannot link store after state initialisation');
        }
        if (process.env.NODE_ENV !== 'production') {
            if (store.name in this.stores) {
                throw new TypeError("Store with name `" + store.name + "` already present in state");
            }
        }
        stores[store.name] = store;
        store.update$.subscribe(function (value) {
            // Shallow copy value and overwrite so new keys can be added
            _this.history[_this.historyIndex] = __assign({}, _this.value);
            _this.value[store.name] = value;
            if (process.env.NODE_ENV !== 'production') {
                Object.freeze(_this.value);
            }
        });
        return store;
    };
    State.prototype.pushNextValueToHistory = function (nextValue) {
        while (this.historyIndex < this.history.length - 1) {
            this.history.pop();
        }
        if (this.history.length === this.config.maxHistoryLength) {
            this.history.shift();
        }
        else {
            this.historyIndex++;
        }
        this.history.push(nextValue);
    };
    State.prototype.go = function (traversalAmount) {
        var initialState = this.value;
        var nextHistoryIndex = this.historyIndex + traversalAmount;
        if (nextHistoryIndex > this.history.length - 1 ||
            nextHistoryIndex < 0) {
            throw new RangeError('History index out of bounds');
        }
        this.isTraversing = true;
        this.historyIndex = nextHistoryIndex;
        for (var key in this.stores) {
            var store = this.stores[key];
            if (this.value[store.name] !== initialState[store.name]) {
                store.update$.next(store.value);
            }
        }
        this.isTraversing = false;
    };
    return State;
}());
exports.default = State;
//# sourceMappingURL=State.js.map